import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "../../../lib/axios";

// ── Recurring payment (saved card, client-level, for Recurring Schedules) ────
// Stripe is the payment gateway used in production. Mirrors the shape of the
// (now-unused) GoCardless mandate hooks — same UI concept (a per-client
// "recurring payment status"), different gateway underneath.

export type TStripeRecurringStatus =
  | "pending_submission"
  | "active"
  | "failed"
  | "cancelled"
  | "expired"
  | null;

export const useStripeRecurringPaymentStatus = (clientId?: number | null) =>
  useQuery({
    queryKey: ["stripe", "recurring-payment-status", clientId],
    queryFn: async () => {
      const res = await axios.get(`/integrations/stripe-connect/client/${clientId}/recurring-payment-status`);
      return res.data.data as { status: TStripeRecurringStatus; payment_method_id: string | null };
    },
    enabled: !!clientId,
    staleTime: 30000,
    refetchOnWindowFocus: false,
    retry: false,
  });

export const useSetupStripeRecurringPayment = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (clientId: number) => {
      const res = await axios.post(`/integrations/stripe-connect/client/${clientId}/setup-recurring-payment`);
      return res.data.data as { url: string };
    },
    onSuccess: (_data, clientId) => {
      qc.invalidateQueries({ queryKey: ["stripe", "recurring-payment-status", clientId] });
    },
  });
};
